"use client"

import * as React from "react"
import { HoverSlider, HoverSliderImage, HoverSliderImageWrap, TextStaggerHover } from "Components/ui/animated-slideshow"
import playingImg from "assets/hero/playing.png"
import tanningImg from "assets/hero/tanning.png"
import relaxingImg from "assets/hero/relaxing.png"

const SLIDES = [
  {
    id: "melanin",
    title: "Melanin Index",
    body:
      "Measures skin pigmentation levels to understand your natural protection against UV radiation and track changes over time.",
    imageUrl: playingImg,
  },
  {
    id: "erythema",
    title: "Erythema Index",
    body:
      "Detects skin redness and inflammation caused by sun exposure, providing early warning signs of overexposure.",
    imageUrl: tanningImg,
  },
  {
    id: "ita",
    title: "Individual Typology Angle",
    body: "Comprehensive skin assessment combining melanin and erythema to classify your unique skin type and sun sensitivity.",
    imageUrl: relaxingImg,
  },
  {
    id: "early-detection",
    title: "Early Detection Saves Skin",
    body: "Identify sun damage before it becomes visible to the naked eye.",
    imageUrl:
      "https://images.unsplash.com/photo-1526256262350-7da7584cf5eb?q=80&w=2400&auto=format&fit=crop",
  },
]

export function ScientificFoundationSlideshow() {
  return (
    <section className="rounded-[2rem] border border-white/10 bg-white/5 p-8 md:p-10">
      <HoverSlider>
        <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
          <div>
            <p className="text-sm font-semibold uppercase tracking-[0.24em] text-orange-300">Scientific Foundation</p>
            <h2 className="mt-4 text-4xl font-semibold tracking-tight">Advanced Color Analysis &amp; Computer Vision</h2>
            <p className="mt-4 max-w-xl text-white/70 leading-relaxed">
              Our app uses cutting-edge dermatological science combined with AI-powered image analysis to monitor your skin health in
              real-time.
            </p>

            <div className="mt-8 space-y-3">
              {SLIDES.map((slide, index) => (
                <div key={slide.id} className="group">
                  <TextStaggerHover
                    index={index}
                    text={slide.title}
                    className="cursor-pointer text-2xl font-semibold tracking-tight text-white"
                  />
                  <p className="mt-2 max-w-xl text-white/65">{slide.body}</p>
                </div>
              ))}
            </div>

            <div className="mt-8 rounded-2xl border border-orange-400/20 bg-orange-400/10 p-5">
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-orange-300">Scientific skin analysis</p>
              <p className="mt-2 text-2xl font-semibold text-white">Early Detection Saves Skin</p>
              <p className="mt-2 text-white/70">Identify sun damage before it becomes visible to the naked eye</p>
              <p className="mt-4 text-4xl font-semibold text-white">95%</p>
              <p className="text-white/60">Detection Accuracy</p>
            </div>
          </div>

          <div className="relative">
            <HoverSliderImageWrap className="aspect-[4/5] w-full overflow-hidden rounded-[2rem] border border-white/10 bg-black/40">
              {SLIDES.map((slide, index) => (
                <div key={slide.id} className="size-full">
                  <HoverSliderImage
                    index={index}
                    imageUrl={slide.imageUrl}
                    src={slide.imageUrl}
                    alt={slide.title}
                    className="size-full object-cover"
                    loading="eager"
                    decoding="async"
                  />
                </div>
              ))}
            </HoverSliderImageWrap>
          </div>
        </div>
      </HoverSlider>
    </section>
  )
}

